export default "__VITE_ASSET__EUfamqL___"